import { render, staticRenderFns } from "./PointsPackagesList.vue?vue&type=template&id=e56b2b9e&scoped=true&"
import script from "./PointsPackagesList.vue?vue&type=script&lang=js&"
export * from "./PointsPackagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56b2b9e",
  null
  
)

export default component.exports